import {
  LIST_PLURALL_IMPORT_ISSUES_REQUEST,
  LIST_PLURALL_IMPORT_ISSUES_SUCCESS,
  LIST_PLURALL_IMPORT_ISSUES_ERROR,
  RESOLVE_PLURALL_UNMATCHED_REQUEST,
  RESOLVE_PLURALL_UNMATCHED_SUCCESS,
  RESOLVE_PLURALL_UNMATCHED_ERROR,
  RESOLVE_PLURALL_PROCESS_ISSUE_REQUEST,
  RESOLVE_PLURALL_PROCESS_ISSUE_SUCCESS,
  RESOLVE_PLURALL_PROCESS_ISSUE_ERROR,
  RESET_STATE_REDUX,
  RESET_STATE_ALL_APPLICATION,
} from '../actions';

const INIT_STATE = {
  processIssues: [],
  unmatchedStudents: [],
  loading: false,
  resolvingId: null,
  resolvingProcessIssueId: null,
  pendingFetchKey: null,
  error: '',
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case RESET_STATE_ALL_APPLICATION:
      return INIT_STATE;
    case RESET_STATE_REDUX:
      return {
        ...state,
        error: '',
      };
    case LIST_PLURALL_IMPORT_ISSUES_REQUEST:
      return {
        ...state,
        loading: true,
        pendingFetchKey: action.payload.fetchKey ?? null,
        error: '',
      };
    case LIST_PLURALL_IMPORT_ISSUES_SUCCESS:
      if (
        action.payload.fetchKey != null &&
        action.payload.fetchKey !== state.pendingFetchKey
      ) {
        return state;
      }
      return {
        ...state,
        loading: false,
        processIssues: action.payload.data.process_issues ?? [],
        unmatchedStudents: action.payload.data.unmatched_students ?? [],
        error: '',
      };
    case LIST_PLURALL_IMPORT_ISSUES_ERROR:
      if (
        action.payload.fetchKey != null &&
        action.payload.fetchKey !== state.pendingFetchKey
      ) {
        return state;
      }
      return {
        ...state,
        loading: false,
        error: action.payload.message,
      };
    case RESOLVE_PLURALL_UNMATCHED_REQUEST:
      return {
        ...state,
        resolvingId: action.payload.id,
        error: '',
      };
    case RESOLVE_PLURALL_UNMATCHED_SUCCESS:
      return {
        ...state,
        resolvingId: null,
      };
    case RESOLVE_PLURALL_UNMATCHED_ERROR:
      return {
        ...state,
        resolvingId: null,
        error: action.payload.message,
      };
    case RESOLVE_PLURALL_PROCESS_ISSUE_REQUEST:
      return {
        ...state,
        resolvingProcessIssueId: action.payload.id,
        error: '',
      };
    case RESOLVE_PLURALL_PROCESS_ISSUE_SUCCESS:
      return {
        ...state,
        resolvingProcessIssueId: null,
      };
    case RESOLVE_PLURALL_PROCESS_ISSUE_ERROR:
      return {
        ...state,
        resolvingProcessIssueId: null,
        error: action.payload.message,
      };
    default:
      return state;
  }
};
